import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    globalErrorTitle: 'Your document could not be added.',
    helpText: 'You can edit your document and import it again to continue.',
    title: 'Your document could not be added for the following reasons:',
  },
  fr: {
    globalErrorTitle: 'Votre document n’a pas pu être ajouté.',
    helpText:
      'Vous pouvez modifier votre document et l’importer à nouveau pour continuer.',
    title:
      'Votre document n’a pas pu être ajouté pour les raisons suivantes\xA0:',
  },
} as const);

export default locales;
